import { isObject } from '../../../../../utils/isObject.js';
import { toCamelCase } from '../../../../../utils/toCamelCase.js';
import { detectAppChanges } from '../../../lib/detectAppChanges.js';

export const appActionArgumentsList = {
  key: 'argumentsList',
  type: 'app',
  label: 'Arguments List',
  isCustom: true,
  path: 'actions[id:{{actionId}}].suggestions.arguments',
  shouldRun: ({ changes, actionId }) => {
    return detectAppChanges(changes, {
      type: 'action',
      actionId,
      keys: ['', 'arguments'],
      custom: () => {
        const appDocsChanged = changes?.filter((n) => n?.type === 'appDoc')?.length > 0;
        const docUrlInValue = changes?.find((n) => n?.value && isObject(n?.value) && n?.value?.documentation?.url);
        return appDocsChanged || docUrlInValue;
      }
    });
  },
  context: ['actionDocs'],
  mapContext: ({ app, action, actionDocs }) => ({
    name: action?.name,
    model: action?.model,
    operation: action?.operation || 'none',
    description: action?.description,
    slug: action?.slug,
    appName: app?.name,
    arguments: action?.arguments,
    actionDocs
  }),
  prompt: 'appActionArgumentsList',
  postProcess: ({ suggestion, existingSuggestion, action }) => {
    const data = suggestion?.suggestion || {};
    const { suggestedValue } = data;

    const mapped = suggestedValue?.map((n) => ({
      ...n,
      location: n?.location === 'unknown' ? (action?.api?.method === 'GET' ? 'query' : 'body') : n?.location,
      key: toCamelCase(n?.externalKey)
    }));

    let filtered = mapped?.filter((n) => !action?.arguments?.some((m) => m?.key === n?.key));

    const hasDismissedKeys = Array.isArray(existingSuggestion?.meta?.dismissedKeys);
    if (hasDismissedKeys) {
      filtered = filtered?.filter((n) => !existingSuggestion?.meta?.dismissedKeys?.includes(n?.key));
    }

    return { ...suggestion, suggestion: { ...data, suggestedValue: filtered } };
  }
};
